import i18n from "../i18n";

export default function getServiceErrorMessage(code) {
    if (!i18n.te('errors.service.' + code)) {
        return i18n.t('errors.unknown');
    }

    return i18n.t('errors.service.' + code);
}